import { render } from "./CityleagueMessage.vue?vue&type=template&id=5be46c42"
import script from "./CityleagueMessage.vue?vue&type=script&lang=js"
export * from "./CityleagueMessage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__